<app-website-header></app-website-header>

<div class="view-all-jobs-container">
    <section class="job-filters-section p-4" [class.active]="showNoRecordsFounds">
        <div class="row jobSections">

            <div class="col-md-3">
                <div class="d-flex">
                    <div class="filters-heading me-2">Filters</div>
                    <mat-chip class="reset-chip" (click)="resetFilters()"><img
                            src="/assets/images/job-filters-reset.svg" alt="job-filters-reset"
                            class="me-1">Reset</mat-chip>
                </div>

                <div class="card mt-3" style="height: 95%;">
                    <div class="card-body">

                        <form [formGroup]="jobFilterForm">

                            <div class="filter-field-container">
                                <div class="filter-label mb-3">Explore Jobs</div>

                                <mat-chip-grid #chipList>
                                    <div *ngFor="let field of getFormFields()">
                                        <ng-container *ngIf="isArray(jobFilterForm.get(field)?.value); else singleChip">
                                          <mat-chip-row *ngFor="let value of jobFilterForm.get(field)?.value" class="reset-chip" [class.d-none]="value === true || value === 'true'">
                                            {{ value }}
                                            <mat-icon matChipRemove (click)="removeArrayItem(field, value)">cancel</mat-icon>
                                          </mat-chip-row>
                                        </ng-container>
                                      
                                        <ng-template #singleChip>
                                          <mat-chip-row *ngIf="jobFilterForm.get(field)?.value" class="reset-chip">
                                            {{ field === 'postedDate' ? (jobFilterForm.get(field)?.value | date: 'yyyy-MM-dd') : jobFilterForm.get(field)?.value }}
                                            <mat-icon matChipRemove (click)="removeField(field)">cancel</mat-icon>
                                          </mat-chip-row>
                                        </ng-template>
                                      </div>

                                      <div class="input-wrapper" style="position: relative;" #searchContainer >
                                    <label class="input-container w-100">
                                        <mat-icon matPrefix class="inp">search</mat-icon>

                                        <input matInput [matChipInputFor]="chipList" placeholder="Search Keyword"
                                            [value]="textFromUniversalSearch ? textFromUniversalSearch : ''"
                                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                            [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="add($event, '')"   (click)="toggleSuggestions(); $event.stopPropagation()"  (input)="searchSuggestionDebouncer($event)" >
                                    </label>
                                    <div  *ngIf="isSugestionOpen" class="search-suggestions" >
                                        <ul>
                                            <li *ngFor="let suggestion of searchSuggestions">
                                                <p (click)="selectedSuggestion(suggestion)"> {{ suggestion.name }} </p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                </mat-chip-grid>
                            </div>

                            <div class="filter-field-container">
                                <mat-expansion-panel>
                                    <mat-expansion-panel-header>
                                        <mat-panel-title class="filter-label"> Region </mat-panel-title>
                                    </mat-expansion-panel-header>

                                    <mat-form-field appearance="outline" class="input-font w-100">
                                        <input #autoCompleteInput matInput [matAutocomplete]="countryAuto"
                                            placeholder="Search for country" [formControl]="countryControl" />
                                        <mat-autocomplete #countryAuto="matAutocomplete"
                                            (optionSelected)="onOptionSelected($event, 'country')">
                                            <mat-option *ngFor="let country of filteredCountries" [value]="country">
                                                {{ country.countryName }}
                                            </mat-option>
                                        </mat-autocomplete>
                                    </mat-form-field>

                                    <mat-form-field appearance="outline" class="input-font w-100 mt-2">
                                        <input #autoCompleteInput matInput [matAutocomplete]="stateAuto"
                                            placeholder="Search for state" [formControl]="stateControl" />
                                        <mat-autocomplete #stateAuto="matAutocomplete"
                                            (optionSelected)="onOptionSelected($event, 'state')">
                                            <mat-option *ngFor="let state of filteredStates" [value]="state">
                                                {{ state.stateName }}
                                            </mat-option>
                                        </mat-autocomplete>
                                    </mat-form-field>
                                    <mat-form-field appearance="outline" class="input-font w-100 mt-2">
                                        <input #autoCompleteInput matInput [matAutocomplete]="cityAuto"
                                            placeholder="Search for city" [formControl]="cityControl" />
                                        <mat-autocomplete #cityAuto="matAutocomplete"
                                            (optionSelected)="onOptionSelected($event, 'city')">
                                            <mat-option *ngFor="let city of filteredCities" [value]="city">
                                                {{ city.cityName }}
                                            </mat-option>
                                        </mat-autocomplete>
                                    </mat-form-field>
                                </mat-expansion-panel>
                            </div>

                            <div class="filter-field-container">
                                <mat-expansion-panel>
                                    <mat-expansion-panel-header>
                                        <mat-panel-title class="filter-label"> Specialities </mat-panel-title>
                                    </mat-expansion-panel-header>

                                    <mat-form-field appearance="outline" class="input-font w-100">
                                        <input #autoCompleteInput matInput [matAutocomplete]="specialityAuto"
                                            placeholder="Search for speciality" [formControl]="specialtyControl" />
                                        <mat-autocomplete #specialityAuto="matAutocomplete"
                                            (optionSelected)="onOptionSelected($event, 'speciality')">
                                            <mat-option *ngFor="let speciality of filteredSpecialities" [value]="speciality">
                                                {{ speciality.specialty }}
                                            </mat-option>
                                        </mat-autocomplete>
                                    </mat-form-field>
                                </mat-expansion-panel>
                            </div>

                            <div class="filter-field-container">
                                <mat-expansion-panel>
                                    <mat-expansion-panel-header>
                                        <mat-panel-title class="filter-label"> Salary Range </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <mat-slider min="0" max="1000000" class="w-100" style="width: 92% !important; margin-left: 15px;">
                                        <input formControlName="salaryFrom" matSliderStartThumb>
                                        <input formControlName="salaryTo" matSliderEndThumb>
                                    </mat-slider>
                                    <p>${{(jobFilterForm.get('salaryFrom')?.value === null) ? 0 : jobFilterForm.get('salaryFrom')?.value}} -
                                        ${{(jobFilterForm.get('salaryTo')?.value === null) ? 0 : jobFilterForm.get('salaryTo')?.value}}</p>
                                </mat-expansion-panel>
                            </div>

                            <div class="filter-field-container">
                                <mat-expansion-panel>
                                    <mat-expansion-panel-header>
                                        <mat-panel-title class="filter-label"> Experience </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <mat-form-field appearance="outline" class="input-font w-100">
                                        <input matInput type="number" placeholder="Experience" min="0" max="99"
                                            formControlName="experience">
                                    </mat-form-field>
                                </mat-expansion-panel>
                            </div>

                            <div class="filter-field-container">
                                <mat-expansion-panel>
                                    <mat-expansion-panel-header>
                                        <mat-panel-title class="filter-label"> Job Type </mat-panel-title>
                                    </mat-expansion-panel-header>

                                    <mat-form-field appearance="outline" class="input-font w-100">
                                        <input #autoCompleteInput matInput [matAutocomplete]="jobTypeAuto"
                                            placeholder="Search for job type" [formControl]="jobTypeControl" />
                                        <mat-autocomplete #jobTypeAuto="matAutocomplete"
                                            (optionSelected)="onOptionSelected($event, 'jobType')">
                                            <mat-option *ngFor="let jobType of filteredJobTypes" [value]="jobType">
                                                {{ jobType.jobType }}
                                            </mat-option>
                                        </mat-autocomplete>
                                    </mat-form-field>
                                </mat-expansion-panel>
                            </div>

                            <div class="filter-field-container">
                                <mat-expansion-panel>
                                    <mat-expansion-panel-header>
                                        <mat-panel-title class="filter-label"> Job Posted </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <mat-form-field appearance="outline" class="fields input-font b-r w-100">
                                        <input matInput [matDatepicker]="postedDate" placeholder="mm/dd/yyyy"
                                            formControlName="postedDate">
                                        <mat-datepicker-toggle matIconSuffix [for]="postedDate"></mat-datepicker-toggle>
                                        <mat-datepicker #postedDate color="primary"></mat-datepicker>
                                    </mat-form-field>
                                </mat-expansion-panel>
                            </div>

                            <div class="filter-field-container">
                                <mat-expansion-panel>
                                    <mat-expansion-panel-header>
                                        <mat-panel-title class="filter-label"> Skills </mat-panel-title>
                                    </mat-expansion-panel-header>

                                    <mat-form-field appearance="outline" class="input-font w-100">
                                        <input #autoCompleteInput matInput [matAutocomplete]="skillsAuto"
                                            placeholder="Search for skill" [formControl]="skillsControl" />
                                        <mat-autocomplete #skillsAuto="matAutocomplete"
                                            (optionSelected)="onOptionSelected($event, 'skills')">
                                            <mat-option *ngFor="let skill of filteredSkills" [value]="skill">
                                                {{ skill.name }}
                                            </mat-option>
                                        </mat-autocomplete>
                                    </mat-form-field>
                                </mat-expansion-panel>
                            </div>

                        </form>
                    </div>
                </div>
            </div>



            <div class="col-md-9">
                <div *ngIf="showNoRecordsFounds; else displayRecords"  class="no-results">
                    <img src="../../../../assets/images/Empty bin.png" alt="no-records-found" class="no-results-image">
                    <div class="no-records-found"> No Jobs Found </div>
                  </div>

                <ng-template #displayRecords>

                    <div class="d-flex displayjobs">
                        <div style="display: flex; align-items: center;" class="sort-by" [class.active]="selectedSortOption">
                            <mat-form-field appearance="outline" class="custom-form-field">
                              <mat-select placeholder="Select Sort Option" [(value)]="selectedSortOption" placeholder="Sort by" (selectionChange)="onSortOptionSelected($event.value)">
                                <mat-option value="alphabetical">Sort by Name</mat-option>
                                <mat-option value="date">Sort Application Start</mat-option>
                                <mat-option value="createdOn">Sort By Created On</mat-option>
                              </mat-select>
                            </mat-form-field>
                            <button *ngIf="selectedSortOption" mat-icon-button (click)="toggleSortDirection()" [attr.aria-label]="currentSortDirection === 'asc' ? 'Sort Descending' : 'Sort Ascending'" >
                              <mat-icon>
                                {{ currentSortDirection === 'asc' ? 'arrow_downward' : 'arrow_upward' }}
                              </mat-icon>
                            </button>
                          </div>
                    </div>

                    <div class="row g-3 jobDetailsContainer">
                        <ng-container *ngFor="let jobPost of obs | async;">
                            <div class="col-md-4">

                                <div class="card mt-3">
                                    <div class="card-header">
                                        <div class="logo-div">
                                            <div class="company-logo-info">
                                           <img *ngIf="!jobPost?.postAnonymously && jobPost?.companyLogo" src="{{jobPost?.companyLogo}}" alt="company logo" class="company-logo">
                                           <img *ngIf="jobPost?.postAnonymously || jobPost?.companyLogo === null" src='/assets/images/companydefault-logo.svg' alt="logo" class="company-logo">
                                           <div *ngIf="!jobPost?.postAnonymously" class="company-name">
                                            {{jobPost?.company.length > 60 ? (jobPost?.company | slice:0:57) + '...' : jobPost?.company}}
                                           </div>
                                        </div>
                                           <img src="{{ !isJobSaved(jobPost) ?'/assets/images/careers-apply-icon.svg':'/assets/images/saved-jobs.svg'}}" style="cursor: pointer;"
                                                (click)="onSaveJob(jobPost)" alt="apply-icon" class="save-icon">
                                        </div>

                                        <div class="mt-1">
                                            <h2>{{jobPost?.title}}</h2>
                                        </div>

                                        <div class="job-info-details">
                                            <div class="job-details-header"><img
                                                    src="/assets/images/careers-map-pin.svg" alt="">
                                                {{jobPost?.city}}, {{jobPost?.state}}, {{jobPost?.country}}
                                            </div>
                                            <div class="d-flex mt-2" style="gap: 30px;">    
                                                <div class="job-details-header"><img src="/assets/images/careers-clock.svg"
                                                    alt="">
                                                {{jobPost?.jobType}}
                                                </div>
                                                <div class="job-details-header">
                                                    <img
                                                        src="/assets/images/careers-calendar.svg" alt="">
                                                        ({{jobPost?.experienceFrom}}-{{jobPost?.experienceTo}} years) 
                                                </div>
                                            </div>

                                        <div class="d-flex flex-column mt-2 mb-2" style="gap: 10px;">
                                            <div class="job-details-header">
                                                <img src="/assets/images/currency-icon.svg" alt="">
                                                
                                                <span *ngIf="jobPost?.hideSalary; else showSalary"> Not disclosed</span>
                                                
                                                <ng-template #showSalary>
                                                    {{ jobPost?.salaryFrom | salary }} - {{ jobPost?.salaryTo | salary }} {{ jobPost?.salaryRange }}
                                                </ng-template>
                                            </div>
                                        </div>
                                    </div>
                                    </div>
                                    <div class="card-body">
                                        <div class="description" [innerHTML]="(jobPost?.description | truncateText:260) + (jobPost?.description.length > 230 ? '...' : '')"></div>
                                        <div class="skills-container">
                                            <span class="skill-badge" *ngFor="let skill of jobPost?.skills.split(',').slice(0, 2)">
                                              {{ skill.trim() }}
                                            </span>
                                          </div>
                                        <button type="button" class="button button-primary read w-auto"
                                            (click)="onReadMore(jobPost?.id)">
                                            Read More ></button><br>
                                        
                                            <div class="apply-div">
                                                <div class="posted-details">
                                                  {{ getPostedDate(jobPost?.createdOn) }} 
                                                  {{ getPostedDate(jobPost?.createdOn) === 1 ? 'day' : 'days' }} ago
                                                </div>
                                              
                                                <ng-container *ngIf="!isApplicationClosed(jobPost?.applicationCloseDate); else closed">
                                                  <button type="button" class="button button-primary w-auto apply-button"
                                                          (click)="onApplyJob(jobPost?.id)">
                                                    <img src="/assets/images/angle-arrow-small-right.svg" alt="angle-arrow-small-right">
                                                    Apply Now
                                                  </button>
                                                </ng-container>
                                              
                                                <ng-template #closed>
                                                  <div class="application-closed">
                                                    <img src="/assets/images/application-closed.svg" alt="application-closed">
                                                    <span>Applications Closed</span>
                                                  </div>
                                                </ng-template>
                                              </div>
                                              
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                    </div>

                </ng-template>

            </div>
        </div>
    </section>

    <mat-paginator class="mat-pagination d-none" [length]="dataSource.data.length" [pageSize]="pageSize"
        *ngIf="!showNoRecordsFounds">
    </mat-paginator>

    <div class="paginator-container" *ngIf="!showNoRecordsFounds">
        <div class="page-numbers">
            <button mat-icon-button class="arrow" (click)="changePage(0)" [disabled]="currentPage === 0">
                <img src="assets/images/pagination_first.svg" alt="pagination_first" srcset="">
            </button>
            <button mat-icon-button (click)="changePage(currentPage - 1)" [disabled]="currentPage === 0">
                <img src="assets/images/pagination_prev.svg" alt="pagination_prev" srcset="">
            </button>

            <ng-container *ngFor="let page of getPageNumbers()">
                <button mat-button *ngIf="page !== '...'" [class.page-active]="currentPage === page"
                    (click)="changePage(+page)">
                    {{ +page + 1 }}
                </button>
                <span *ngIf="page === '...'">...</span>
            </ng-container>
            <button mat-icon-button (click)="changePage(currentPage + 1)"
                [disabled]="currentPage >= getTotalPages() - 1">
                <img src="assets/images/pagination_next.svg" alt="pagination_next" srcset="">
            </button>
            <button mat-icon-button (click)="changePage(getTotalPages() - 1)"
                [disabled]="currentPage >= getTotalPages() - 1">
                <img src="assets/images/pagination_last.svg" alt="pagination_last" srcset="">
            </button>
        </div>
        <div class="jobs-total-entries" *ngIf="totalData !== -1" >
            Total Entries: {{ totalData }}
        </div>
    </div>

</div>

<app-website-footer></app-website-footer>
